import React from "react";
import { Wordmark, GoldRule } from "@/components/Brand";
import { Lock } from "lucide-react";

/**
 * Rendered when the backend reports the Amelia connection isn't configured yet
 * (i.e. AMELIA_API_KEY is empty on the server). This is the ONLY non-live
 * screen in the app — no mock booking data is ever shown.
 */
export function ConnectionState({ configured, providerResolved, baseUrl, onRetry }) {
    return (
        <div className="min-h-[100dvh] flex flex-col items-center justify-center px-6 py-12 text-center">
            <div className="w-full max-w-md" data-testid="connection-state">
                <Wordmark />
                <GoldRule className="mt-6" />

                <div className="mt-10 rounded-3xl glass p-8">
                    <div className="mx-auto h-14 w-14 rounded-full glass flex items-center justify-center border-gold/50 border">
                        <Lock className="h-5 w-5 text-gold" strokeWidth={1.5} />
                    </div>
                    <h1 className="mt-6 font-serif font-light text-3xl leading-tight text-white">
                        {configured ? (
                            <>Connecting to your <span className="gold-text">calendar</span></>
                        ) : (
                            <>Awaiting <span className="gold-text">connection</span></>
                        )}
                    </h1>
                    <p className="mt-4 text-sm text-white/60 leading-relaxed">
                        {configured
                            ? "The Amelia backend is configured, but we couldn't resolve a practitioner. Please try again in a moment."
                            : "The luxury booking experience is ready. It will go live the moment your Amelia API key is added to the server."}
                    </p>

                    <div className="mt-6 text-[10px] uppercase tracking-[0.24em] text-white/40">
                        Backend
                    </div>
                    <div className="mt-1 text-white/70 text-sm font-ui break-all" data-testid="connection-base-url">
                        {baseUrl || "https://wp.poutaesthetics.co.uk"}
                    </div>

                    <button
                        onClick={onRetry}
                        className="mt-8 rounded-full border hairline px-6 py-3 text-sm text-gold hover:bg-gold/10 transition-colors"
                        data-testid="connection-retry-button"
                    >
                        Check connection
                    </button>
                </div>

                <p className="mt-6 text-xs text-white/35">
                    Configured: {String(configured)} · Practitioner resolved: {String(providerResolved)}
                </p>
            </div>
        </div>
    );
}
